import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewClubPageNew from "../../components/Club/ViewClubPageNew";

const ViewClubPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="View"   title2="Club Management" 
        link2="/club" 
         />

        <ViewClubPageNew />
      </MasterLayout>
    </>
  );
};

export default ViewClubPage;
